import { environment } from 'src/environments/environment';

const ENV = environment.production ? 'prod' : 'dev';
const API_REGEX = /^https:\/\/.*\.travelvip\.ai$/;

const LOG_LEVEL = {
  INFO: 'INFO',
  ERROR: 'ERROR',
  WARN: 'WARN',
} as const;

type LogLevel = (typeof LOG_LEVEL)[keyof typeof LOG_LEVEL];

export { ENV, API_REGEX, LOG_LEVEL, LogLevel };
